import { render, staticRenderFns } from "./QueryUmbrellaI.vue?vue&type=template&id=620cb6ee&"
import script from "./QueryUmbrellaI.vue?vue&type=script&lang=js&"
export * from "./QueryUmbrellaI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports